import { inject, Injectable } from '@angular/core';
import { openCiSnackbar } from '@iurban-malaga/cicerone-ui';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class Snackbar {
  private _translateService = inject(TranslateService);

  public showSuccessSnackbar(message: string, duration?: number) {
    openCiSnackbar({
      content: this._translateService.instant(message),
      status: 'success',
      'icon-name': 'btn-check',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: duration ?? 4000
    })
  } 
  
  public showErrorSnackbar(message: string, duration?: number) {
    openCiSnackbar({
      content: this._translateService.instant(message),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: duration ?? 4000
    })
  }
}
